
import { supabase } from "@/integrations/supabase/client";
import { SignInData, AuthResult, SupabaseAuthResponse } from "./types";

export const signIn = async (data: SignInData): Promise<AuthResult> => {
  try {
    console.log('Attempting to sign in with email:', data.email);
    
    const { data: authData, error } = await supabase.auth.signInWithPassword({
      email: data.email,
      password: data.password,
    }) as SupabaseAuthResponse;

    if (error) {
      console.error('Sign in error:', error.message);
      
      // Handle specific error cases with user-friendly messages
      if (error.message.includes('Invalid login credentials')) {
        return { 
          data: null, 
          error: { 
            message: 'Invalid email or password. Please check your credentials and try again.' 
          } 
        };
      }
      
      if (error.message.includes('Email not confirmed')) {
        return { 
          data: null, 
          error: { 
            message: 'Your email is not confirmed yet. Please contact an administrator or check your email for the confirmation link.' 
          } 
        };
      }
      
      // Network or server errors
      if (error.message.includes('Failed to fetch') || error.message.includes('network')) {
        console.error('Network error during sign in:', error);
        return { 
          data: null, 
          error: { 
            message: 'Network error. Please check your internet connection and try again.' 
          } 
        };
      }
      
      // Rate limiting
      if (error.message.includes('rate limit')) {
        return { 
          data: null, 
          error: { 
            message: 'Too many login attempts. Please wait a moment before trying again.' 
          } 
        };
      }
      
      // Fallback for other errors
      return { 
        data: null, 
        error: { 
          message: error.message || 'An error occurred during sign in. Please try again.' 
        } 
      };
    }

    if (!authData?.session) {
      console.error('No session data received after successful sign in');
      return { 
        data: null, 
        error: { 
          message: 'Authentication failed. No session created.' 
        } 
      };
    }

    console.log('Sign in successful for user:', authData.session.user.email);
    return { data: authData, error: null };

  } catch (error: any) {
    console.error('Unexpected error during sign in:', error);
    
    // Handle network errors specifically
    if (!navigator.onLine) {
      return { 
        data: null, 
        error: { 
          message: 'You appear to be offline. Please check your internet connection.' 
        } 
      };
    }

    return { 
      data: null, 
      error: { 
        message: error?.message || 'An unexpected error occurred. Please try again.' 
      } 
    };
  }
};
